// main.js - Remove ALL ServiceWorker code
import { createApp } from "vue";
import { createPinia } from "pinia";
import App from "./App.vue";
import router from "./router";
import { useAuthStore } from "@/stores/auth";

// Global styles
import "@/styles/main.scss";

// Create app
const app = createApp(App);
const pinia = createPinia();

app.use(pinia);
app.use(router);

// Initialize auth with caching
const authStore = useAuthStore();

// Start auth initialization but don't block mounting
const initPromise = authStore.initialize();

// Mount app immediately
app.mount("#app");

// When auth is ready, update the app state
initPromise
  .then(() => {
    console.log("✅ Auth ready, app fully initialized");
  })
  .catch((error) => {
    console.warn("⚠️ Auth initialization had issues:", error);
  });

// Handle online/offline events
window.addEventListener("online", () => {
  console.log("📶 App is back online - refreshing data...");
  if (authStore.isAuthenticated) {
    authStore.refreshUserInBackground();
  }
});

window.addEventListener("offline", () => {
  console.warn("📶 App is offline - using cached data");
});

// NO ServiceWorker code anywhere!

export default app;
